import type { SubscriptionPlan } from './costCalculations';

export const calculatePaymentDate = (plan: SubscriptionPlan): string => {
  const now = new Date();
  const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
  ];

  const y = now.getUTCFullYear();
  const m = now.getUTCMonth();
  const d = now.getUTCDate();

  if (plan === 'year') {
    const futureDate = new Date(Date.UTC(y + 1, m, d));
    return `${futureDate.getUTCDate()} ${months[futureDate.getUTCMonth()]} ${futureDate.getUTCFullYear()}`;
  } else {
    const futureDate = new Date(Date.UTC(y, m + 1, d));
    return `${futureDate.getUTCDate()} ${months[futureDate.getUTCMonth()]} ${futureDate.getUTCFullYear()}`;
  }
};
